import React from 'react';
import { gql } from '@yi/core';

import { graphql, PageProps } from 'gatsby';
import { MainLayout, SeriesItemPage } from '~/components';
import { SeriesHomePageContext } from '~/src/common/lean-back';

export const Series: React.FC<PageProps<gql.typesSsr.Query_Series, SeriesHomePageContext>> = ({
  data,
}) => {
  const { yi } = data;
  if (!yi) {
    return null;
  }

  return (
    <MainLayout pageTitle={yi.Series.title}>
      <SeriesPage content={yi.Series} />
    </MainLayout>
  );
};

interface Props {
  content: Omit<gql.typesSsr.Query_Series_yi_Series, '__typename'>;
}

export const SeriesPage: React.FC<Props> = ({ content }) => {
  return <SeriesItemPage series={content} />;
};

// @TODO co-locate with SeriesCard when it is created
export const fragment = graphql`
  fragment Fragment_SeriesCard on YI_Series {
    __typename
    id
    title
    localized_path
    entry_date {
      yyyymmdd
      timestamp
    }
    language
    cast
    thumbnail {
      processed_url
    }
    seasons {
      id
      episodes {
        id
      }
    }
  }
`;

export const query = graphql`
  query Query_Series($id: ID!) {
    yi {
      Series(id: $id) {
        __typename
        id
        title
        url_title
        path
        full_url
        localized_path
        entry_date {
          yyyymmdd
        }
        edit_date {
          yyyymmdd
        }
        language
        cast
        hero(params: { width: 1600 }) {
          processed_url
        }
        thumbnail {
          processed_url
        }
        trailer {
          brightcove_id
        }
        description
        short_description

        seasons {
          id
          seasonNum
          title
          next_episode_release_date {
            iso8601
          }
          episodes {
            id
            seasonNum
            episodeNum
            title
            media {
              brightcove_id
            }
            media_duration {
              seconds
              minutes
            }
            cast
            hero {
              processed_url
            }
            thumbnail {
              processed_url
            }
            trailer {
              brightcove_id
            }
            description
            short_description
          }
        }
      }
    }
  }
`;

// eslint-disable-next-line import/no-default-export
export default Series;
